import { useProjectScanServices } from '@witmetrics/data-store';
import { mapToId, sortByCreatedAt } from '@witmetrics/utils/arrays';
import { isEmpty } from '@witmetrics/utils/misc';
import { useAppState } from '@/providers/AppStateProvider';
import Section from '@/overlays/CaseOverlay/Section';
import SectionTitle from '@/overlays/CaseOverlay/SectionTitle';
import ScanServicesList from '@/components/ScanServicesList';
import Divider from '@/components/Divider';
import { classes } from './utils';

export type ServicesSectionProps = {
  isFetchingData?: boolean;
};

export default function ServicesSection({
  isFetchingData,
}: ServicesSectionProps) {
  const { activeProjectId } = useAppState();
  const scanServices = useProjectScanServices(activeProjectId!);

  if (isFetchingData || isEmpty(scanServices)) return null;

  return (
    <>
      <Section>
        <SectionTitle
          title="Scan Services"
          newLabel="Add service"
          // onAddNew={() => null /* TODO */}
        />
        <ScanServicesList
          isFetchingData={isFetchingData}
          className={classes.servicesList}
          serviceIds={mapToId(sortByCreatedAt(scanServices))}
          variant="card"
        />
      </Section>
      <Divider />
    </>
  );
}
